<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <material-card color="green" title="Crash Course Materials">
          <v-form ref="courseSelectionFrom" v-model="valid" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 md6>
                <v-select
                  :items="courseList"
                  label="Select Crash Course"
                  item-text="name"
                  item-value="id"
                  v-model="course.course_id"
                  class="mt-2"
                  @change="onSelectCourse(course.course_id)"
                  :rules="courseIDRules"
                ></v-select>
              </v-flex>

              <v-flex xs12 md6>
                <!--   clearable -->
                <v-select
                  :items="courseSubjectList"
                  label="Select Subject"
                  item-text="name"
                  item-value="id"
                  v-model="course.subject_id"
                  class="mt-2"
                  :rules="subject_IDRules"
                  @input="onSelectSubject(course.course_id, course.subject_id)"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </material-card>
      </v-flex>

      <!-- <ExamList :AllExamList="allExams" v-if="question.subject_id" /> -->

      <v-flex xs12 md12 v-if="courseSubjectDetail">
        <v-flex xs12 v-if="courseSubjectDetail.result">
          <v-btn @click="uploadQuiz" color="success" style="float: right" dark>
            Add Quiz
          </v-btn>
        </v-flex>
        <material-card
          color="green"
          style="margin-top: 70px"
          title="Quiz List"
          text
          v-if="courseSubjectDetail.result"
        >
          <v-data-table
            :headers="headersQuiz"
            :items="courseSubjectDetail.result.quizzes"
          >
            <template slot="items" slot-scope="{ item }">
              <td class="click-route">{{ item.name }}</td>
              <td>{{ item.quiz_duration }}</td>
              <td>{{ item.quiz_question_number }}</td>
              <td>{{ item.quiz_total_mark }}</td>
              <td>{{ item.quiz_negative_mark }}</td>
              <td>{{ item.sort }}</td>

              <!-- <td>
                <v-btn @click="getExamId(item)" color="success" dark>Add question</v-btn>
          </td> -->
            </template>
          </v-data-table>
        </material-card>

        <v-flex xs12 v-if="courseSubjectDetail.result">
          <v-btn
            @click="uploadScript"
            color="success"
            style="float: right"
            dark
          >
            Add Script
          </v-btn>
        </v-flex>
        <material-card
          color="green"
          style="margin-top: 70px"
          title="Script List"
          text
          v-if="courseSubjectDetail.result"
        >
          <v-data-table
            :headers="headersScript"
            :items="courseSubjectDetail.result.scripts"
          >
            <template slot="items" slot-scope="{ item }">
              <td class="click-route">{{ item.name }}</td>
              <td>{{ item.script_url }}</td>
              <td>{{ item.sort }}</td>
              <td></td>

              <!-- <td>
                <v-btn @click="getExamId(item)" color="success" dark>Add question</v-btn>
          </td> -->
            </template>
          </v-data-table>
        </material-card>

        <v-flex xs12 v-if="courseSubjectDetail.result">
          <v-btn @click="uploadVideo" color="success" style="float: right" dark>
            Add Video
          </v-btn>
        </v-flex>
        <material-card
          color="green"
          style="margin-top: 70px"
          title="Video List"
          text
          v-if="courseSubjectDetail.result"
        >
          <v-data-table
            :headers="headersVideo"
            :items="courseSubjectDetail.result.videos"
          >
            <template slot="items" slot-scope="{ item }">
              <td class="click-route">{{ item.name }}</td>
              <td>{{ item.video_url }}</td>
              <td>{{ item.video_full_url }}</td>
              <td>{{ item.sort }}</td>
              <td></td>

              <!-- <td>
                <v-btn @click="getExamId(item)" color="success" dark>Add question</v-btn>
          </td> -->
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-dialog persistent v-model="dialogQuiz" width="1000" hegiht="auto">
        <material-card color="green" title="Crash Course Quiz">
          <v-form ref="form">
            <v-container py-0>
              <v-layout wrap>
                <v-flex class="md6">
                  <v-text-field
                    type="test"
                    v-model="examObj.quiz_name"
                    class="mt-4"
                    placeholder="Quiz name"
                  ></v-text-field>
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    type="test"
                    v-model="examObj.quiz_name_bn"
                    class="mt-4"
                    placeholder="Quiz name bangla"
                  ></v-text-field>
                </v-flex>

                <v-flex class="md6">
                  <v-text-field
                    type="number"
                    v-model="examObj.duration"
                    class="mt-4"
                    placeholder="Duration"
                  ></v-text-field>
                </v-flex>

                <v-flex class="md6">
                  <v-text-field
                    type="number"
                    v-model="examObj.positive_mark"
                    class="mt-4"
                    placeholder="Positive Mark"
                  ></v-text-field>
                </v-flex>

                <v-flex class="md6">
                  <v-text-field
                    type="number"
                    v-model="examObj.negative_mark"
                    class="mt-4"
                    placeholder="Negative Mark"
                  ></v-text-field>
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    type="number"
                    v-model="examObj.total_mark"
                    class="mt-4"
                    placeholder="Total Mark"
                  ></v-text-field>
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    type="number"
                    v-model="examObj.question_number"
                    class="mt-4"
                    placeholder="Question Number"
                  ></v-text-field>
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    type="number"
                    v-model="examObj.sort"
                    class="mt-4"
                    placeholder="Sort"
                  ></v-text-field>
                </v-flex>

                <v-flex class="md6">
                  <label class="pr-2"> Question file upload : </label>
                  <input
                    type="file"
                    ref="excelFile"
                    @change="importExcel($event)"
                  />
                </v-flex>

                <v-flex xs12 text-xs-right>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                    @click="onSubmitQuiz"
                    >Save</v-btn
                  >
                  <v-btn
                    class="mx-2 font-weight-light"
                    color="info"
                    @click="closeModal"
                    >Close</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <v-divider />
        </material-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogScript" width="800" hegiht="auto">
        <material-card color="green" title="Crash Course Script">
          <v-form ref="formScript">
            <v-container py-0>
              <v-layout wrap>
                <v-flex class="md6">
                  <v-text-field
                    type="text"
                    label="Title"
                    class="green-input"
                    v-model="script.title"
                    prepend-icon="text_fields"
                    :rules="titleRule"
                  />
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    type="text"
                    label="Title (Bangla)"
                    class="green-input"
                    v-model="script.title_bn"
                    prepend-icon="text_fields"
                  />
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    type="number"
                    label="Sort"
                    class="green-input"
                    v-model="script.sort"
                  />
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    label="Script file"
                    @click="pickFile"
                    v-model="scriptFileName"
                    prepend-icon="attach_file"
                    class="green-input"
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileScript"
                    @change="onFilePicked"
                    :rules="fileRule"
                  />
                </v-flex>

                <v-flex xs12 text-xs-right>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                    @click="onSubmitScript"
                    >Save</v-btn
                  >
                  <v-btn
                    class="mx-2 font-weight-light"
                    color="info"
                    @click="closeModalScript"
                    >Close</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <v-divider />
        </material-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogVideo" width="800" hegiht="auto">
        <material-card color="green" title="Crash Course Video">
          <v-form ref="formVideo">
            <v-container py-0>
              <v-layout wrap>
                <v-flex md12>
                  <div class="progress_parent">
                    <b class="textCenter">
                      {{
                        uploadPercentage < 100
                          ? uploadPercentage + " %"
                          : "Processing"
                      }}</b
                    >
                    <div
                      class="progress_child"
                      :style="{ width: uploadPercentage + '%' }"
                    ></div>
                  </div>
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    type="text"
                    label="Title"
                    class="green-input"
                    v-model="video.title"
                    prepend-icon="text_fields"
                    :rules="titleRule"
                  />
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    type="text"
                    label="Title Bangla"
                    class="green-input"
                    v-model="video.title_bn"
                    prepend-icon="text_fields"
                  />
                </v-flex>
                <v-flex md12>
                  <v-text-field
                    type="text"
                    label="Description"
                    class="green-input"
                    v-model="video.description"
                    prepend-icon="description"
                  />
                </v-flex>
                <v-flex md6>
                  <v-text-field
                    type="number"
                    label="Sort"
                    class="green-input"
                    v-model="video.sort"
                  />
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    label="Video"
                    @click="pickFileVideo"
                    prepend-icon="attach_file"
                    v-model="videoName"
                    class="green-input"
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="fileVideo"
                    accept="video/*"
                    @change="onFilePickedVideo"
                    :rules="videoRule"
                  />
                </v-flex>
                <v-flex class="md6">
                  <v-text-field
                    v-model="thumbnailName"
                    label="Thumbnail"
                    @click="pickThumbnail"
                    prepend-icon="attach_file"
                    class="green-input"
                  ></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="thumbnail"
                    accept="image/*"
                    @change="onThumbnailPicked"
                    :rules="thumbnailRule"
                  />
                </v-flex>

                <v-flex xs12 text-xs-right>
                  <v-btn
                    :disabled="disableButton"
                    class="mx-0 font-weight-light"
                    color="success"
                    @click="onSubmitVideo"
                    >Save</v-btn
                  >
                  <v-btn
                    :disabled="disableButton"
                    class="mx-2 font-weight-light"
                    color="info"
                    @click="closeModalVideo"
                    >Close</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <v-divider />
        </material-card>
      </v-dialog>

      <v-snackbar
        :color="color"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbar"
        dark
      >
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div>{{ noticeMessage }}</div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import FormExamQuestion from "@/views/FormExamQuestion";
import Form from "@/views/Form";
import ExamList from "@/views/ExamList";
import FormLecture from "@/views/FormLecture";
import xlsx from "xlsx";
export default {
  metaInfo() {
    return {
      title: "Crash Course Material | Admin",
    };
  },
  components: {
    Form,
    FormExamQuestion,
    FormLecture,
    ExamList,
  },
  computed: {
    ...mapState("crashCourseMaterials", [
      "courseList",
      "course",
      "courseSubjectList",
      "courseSubjectDetail",

      "courseDetail",
      "subjectDetail",
      "subjectListNotInCourse",
      "chapterList",
      "examList",
      "lecture_videoList",
      "examDetail",
      "question",
      "quiz_title",
      "uploadPercentage",
    ]),
  },
  mounted() {
    this.getcrashCourselist();
    //  this.getCourseSubjectList(this.$route.params.id);
    //  this.getCourseDetails(this.$route.params.id);
  },
  data() {
    return {
      
      valid: true,
      examObj: {},
      panel: [false],
      valid: true,
      color: null,
      chapter: {},
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      headersQuiz: [
        {
          sortable: true,
          text: "Quiz name",
          value: "exam_name",
        },
        {
          sortable: true,
          text: "Duration",
          value: "duration",
        },
        {
          sortable: true,
          text: "Total questions",
          value: "question_number",
        },
        {
          sortable: true,
          text: "Marks",
          value: "total_mark",
        },
        {
          sortable: true,
          text: "Negative Mark",
          value: "negative_mark",
        },
        {
          sortable: false,
          text: "Action",
          value: "",
        },
      ],
      headersScript: [
        {
          sortable: true,
          text: "Script name",
          value: "name",
        },
        {
          sortable: true,
          text: "Script Url",
          value: "script_url",
        },

        {
          sortable: true,
          text: "Sort",
          value: "sort",
        },
        {
          sortable: false,
          text: "Action",
          value: "",
        },
      ],
      headersVideo: [
        {
          sortable: true,
          text: "Vidoe name",
          value: "name",
        },
        {
          sortable: true,
          text: "Video Url",
          value: "video_url",
        },
        {
          sortable: true,
          text: "Video Full Url",
          value: "video_full_url",
        },

        {
          sortable: true,
          text: "Sort",
          value: "sort",
        },
        {
          sortable: false,
          text: "Action",
          value: "",
        },
      ],
      dialogQuiz: false,
      dialogScript: false,
      dialogVideo: false,
      dialogQuestion: false,

      dialog: false,
      dialogChapter: false,
      lectureDialog: false,
      noticeMessage: "",
      valueObj: {},
      chapterNameRules: [(v) => !!v || "Chapter is required"],
      subject_IDRules: [(v) => !!v || "Please select subject"],
      chapter_IDRules: [],
      quiz_IDRules: [(v) => !!v || "Please select quiz"],
      courseIDRules: [(v) => !!v || "Please select subject"],
      lecture_IDRules: [],

      item: {
        title: "Add new Question",
        subTitle: "This is the subtitle",
        width: "md6",
        submitText: "Submit",
      },
      valueObj: {},

      chapterItem: {
        title: "Create New Chapter",
        // 'subTitle': 'This is the subtitle',
        width: "md6",
        submitText: "Submit",
      },
      chapterInputFields: [
        {
          label: "Chapter Name",
          type: "text",
          isEnable: true,
          name: "name",
          formName: "Chapter name",
          nameRules: [
            (v) => !!v || "Chapter name is required",
            (v) =>
              (v && v.length <= 190) ||
              "Chapter name must be less than 190 characters",
          ],
        },
        {
          label: "Chapter Name Bangla",
          type: "text",
          isEnable: true,
          name: "name_bn",
          formName: "Chapter name bangla",
          nameRules: [
            (v) => !!v || "Chapter name Bangla is required",
            (v) =>
              (v && v.length <= 190) ||
              "Chapter name Bangla must be less than 190 characters",
          ],
        },
        {
          label: "Price",
          type: "number",
          isEnable: true,
          name: "price",
          formName: "price",
          nameRules: [(v) => !!v || "Price is required"],
        },
      ],
      lectureItem: {
        title: "Add new Lecture Video",
        subTitle: "This is the subtitle",
        width: "md6",
        submitText: "Submit",
      },
      lectureValueObj: {},
      allExams: [],
      disableButton: false,
      script: {},
      scriptFileName: "",
      titleRule: [(v) => !!v || "Title is required."],
      fileRule: [(v) => !!v || "File is required."],
      video: {},
      videoName: "",
      thumbnailName: "",
      titleRule: [(v) => !!v || "Title is required."],
      videoRule: [(v) => !!v || "Video is required."],
      thumbnailRule: [(v) => !!v || "Thumbnail is required."],
      durationRule: [],
    };
  },
  created() {
    this.$store.state.crashCourseMaterials.question = {};
  },
  watch: {
    // examList: function (val) {
    //   this.allExams = this.examList;
    // },
  },
  methods: {
    ...mapActions("crashCourseMaterials", [
      "getcrashCourselist",
      "getCourseSubjectList",
      "getCourseSubjectDetails",
      "storeCrashCourseQuiz",
      "storeScript",
      "storeVideo",

      "fetchData",
      "CreateCourse",
      "getSubjectListNotInCourse",
      "addSubjectToCourse",
      "getCourseDetails",
      "getChapterNameListBySubjectId",
      "storeChapter",
      "getExamDetailById",
      "getLectureDetails",
      "storeLectureVideo",
      "getExamListByChapter",
    ]),

    uploadQuiz() {
      this.dialogQuiz = true;
    },
    uploadScript() {
      this.dialogScript = true;
    },
    uploadVideo() {
      this.dialogVideo = true;
    },

    closeModal() {
      this.dialogQuiz = false;
      this.$refs.form.reset();
      this.$refs.excelFile.value = null;
      this.questions = [];
    },

    closeModalScript() {
      this.dialogScript = false;
      this.$refs.formScript.reset();
      this.$refs.fileScript.value = null;
      this.script = {};
    },
    closeModalVideo() {
      this.dialogVideo = false;
      this.$refs.formVideo.reset();
      this.$refs.fileVideo.value = null;
      this.$refs.thumbnail.value = null;
      this.video = {};
    },
    importExcel(e) {
      const files = e.target.files;
      if (!files.length) {
        return;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        return alert(
          "The upload format is incorrect. Please upload xls or xlsx format"
        );
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const XLSX = xlsx;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet

          this.questions = [];
          // Edit data
          for (var i = 0; i < ws.length; i++) {
            this.questions.push({
              question: ws[i].question,
              option1: ws[i].option1,
              option2: ws[i].option2,
              option3: ws[i].option3,
              option4: ws[i].option4,
              option5: ws[i].option5 ? ws[i].option5 : null,
              option6: ws[i].option6 ? ws[i].option6 : null,
              correct_answer: ws[i].correct_answer
                ? ws[i].correct_answer
                : null,
              correct_answer2: ws[i].correct_answer2
                ? ws[i].correct_answer2
                : null,
              correct_answer3: ws[i].correct_answer3
                ? ws[i].correct_answer3
                : null,
              correct_answer4: ws[i].correct_answer4
                ? ws[i].correct_answer4
                : null,
              correct_answer5: ws[i].correct_answer5
                ? ws[i].correct_answer5
                : null,
              correct_answer6: ws[i].correct_answer6
                ? ws[i].correct_answer6
                : null,
              explanation_text: ws[i].explanation_text
                ? ws[i].explanation_text
                : null,
            });
          }

          // if(this.excelQuestions.length > 0){
          //  // this.uploadQuestions();
          // }
        } catch (e) {
          return alert("Read failure!");
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },
    onSubmitQuiz() {
      const obj = {
        course_id: this.course.course_id,
        subject_id: this.course.subject_id,
        quiz_name: this.examObj.quiz_name,
        quiz_name_bn: this.examObj.quiz_name_bn,
        duration: Number(this.examObj.duration),
        total_mark: Number(this.examObj.total_mark),
        question_number: Number(this.examObj.question_number),
        positive_mark: Number(this.examObj.positive_mark),
        negative_mark: Number(this.examObj.negative_mark),
        sort: Number(this.examObj.sort),
        status: "Available",
        questions: this.questions,
      };

      this.storeCrashCourseQuiz(obj).then((response) => {
        console.log(response);
        if (response.status == "OK") {
          this.closeModal();
          this.color = "success";
          this.noticeMessage = "Success! " + response.messages;
          this.snack("top");
          this.getCourseSubjectDetails(this.course.subject_id);
        } else {
          this.color = "warning";
          this.noticeMessage = "Warning! " + response.messages;
          this.snack("top");
        }
      });
    },
    pickFile() {
      this.$refs.fileScript.click();
    },
    onFilePicked(e) {
      this.scriptFileName = e.target.files[0].name;
    },
    onSubmitScript() {
      let file = this.$refs.fileScript.files[0];
      if (this.$refs.formScript.validate()) {
        this.script.status = "Available";
        this.script.subject_id = this.course.subject_id;
        this.script.title_bn = this.script.title_bn
          ? this.script.title_bn
          : this.script.title;
        var formData = new FormData();
        formData.append("data", JSON.stringify(this.script));
        formData.append("file", file);

        this.storeScript(formData)
          .then((response) => {
            console.log(response);
            if (response.status == "OK") {
              this.closeModalScript();
              // this.getScriptlistByChapterId(this.$route.params.id)
              this.dialogScript = false;
              this.color = "success";
              this.noticeMessage = response.messages;
              this.snack("top");
              this.getCourseSubjectDetails(this.course.subject_id);
            } else {
              this.noticeMessage = response.messages;
              this.snack("top");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.log("Second");
      }
    },

    pickFileVideo() {
      this.$refs.fileVideo.click();
    },
    pickThumbnail() {
      this.$refs.thumbnail.click();
    },
    onThumbnailPicked(e) {
      this.thumbnailName = e.target.files[0].name;
    },
    onFilePickedVideo(e) {
      this.videoName = e.target.files[0].name;
    },
    onSubmitVideo() {
      let fileVideo = this.$refs.fileVideo.files[0];
      let thumbnail = this.$refs.thumbnail.files[0];
      if (this.$refs.formVideo.validate()) {
        this.video.status = "Available";
        this.video.subject_id = this.course.subject_id;
        this.video.title_bn = this.video.title_bn
          ? this.video.title_bn
          : this.video.title;
        var formData = new FormData();
        formData.append("data", JSON.stringify(this.video));
        formData.append("video", fileVideo);
        formData.append("thumbnail", thumbnail);

        this.disableButton = true;

        this.storeVideo(formData)
          .then((response) => {
            if (response.status == "OK") {
               this.closeModalVideo();
             // this.dialogVideo = false;
              this.disableButton = false;
              this.getCourseSubjectDetails(this.course.subject_id);
              this.color = "success";
              this.noticeMessage = response.messages;
              this.snack("top");
            } else {
              this.noticeMessage = response.messages;
              this.snack("top");
              this.dialogVideo = false;
              this.disableButton = false;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.log("Second");
      }
    },




    getExamId(item) {
      this.examObj = item;
      this.dialogQuestion = true;
      this.$refs.questionInsertionDialog.click();
    },
    closeQuestionModal() {
      this.dialogQuestion = false;
    },
    getBackData(value) {
      console.log(this.question);
      console.log(value);
    },

    onSelectQuiz(quiz_id) {
      let obj = {
        course_id: this.question.course_id,
        subject_id: this.question.subject_id,
        chapter_id: this.question.chapter_id,
        lecture_id: this.question.lecture_id,
        quiz_id: quiz_id,
      };
      this.getExamDetailById(obj);
    },
    onSelectChapter(chapter_id) {
      this.question.lecture_id = null;
      this.getExamListByChapter(chapter_id);
    },
    onSelectLecture(lecture_id) {
      if (this.question.lecture_id) {
        this.getLectureDetails(lecture_id);
      } else {
        let obj = {
          courseId: this.question.course_id,
          subjectId: this.question.subject_id,
        };
        this.getChapterNameListBySubjectId(obj).then((response) => {
          this.allExams = response.exams;
        });
        // this.getChapterNameListBySubjectId(obj).then((response) => {
        //   this.allExams = response.exams;
        // });
      }
    },

    onSelectCourse(course_id) {
      // console.log(this.course.subject_id);
      this.course.subject_id = null;
      this.courseSubjectDetail.result = null;
      this.$refs.courseSelectionFrom.resetValidation();
      this.getCourseSubjectList(course_id);
    },
    onSelectSubject(course_id, subject_id) {
      // this.question.chapter_id = null;
      // this.question.lecture_id = null;
      this.$refs.courseSelectionFrom.resetValidation();
      // let obj = {
      //   courseId: course_id,
      //   subjectId: subject_id,
      // };
      this.getCourseSubjectDetails(subject_id);
      if (this.courseSubjectDetail.status == "OK") {
        console.log(this.courseSubjectDetail.result);
      }
    },

    saveChapter(obj) {
      let loader = this.$loading.show({
        color: "green",
        canCancel: true,
        onCancel: this.onCancel,
        loader: "dots",
        isFullPage: true,
      });
      obj.course_id = this.question.course_id;
      obj.subject_id = this.question.subject_id;
      if (this.$refs.courseSelectionFrom.validate()) {
        this.storeChapter(obj).then((response) => {
          if (response.status == "OK") {
            this.dialogChapter = false;
            this.chapter.name = null;
            this.$refs.courseSelectionFrom.resetValidation();
            this.chapterList.push(response.result);
            this.color = "success";
            this.subject_id = null;
            this.noticeMessage = "Success! " + response.messages;
            this.snack("top");
            loader.hide();
          } else {
            this.color = "warning";
            this.noticeMessage = "Warning! " + response.messages;
            this.snack("top");
            loader.hide();
          }
        });
      } else {
      }
    },
    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }
      this.snackbar = true;
    },
    submitLectureVideo(data) {
      this.disableButton = true;

      this.storeLectureVideo(data)
        .then((response) => {
          if (response.status == "OK") {
            this.lectureDialog = false;
            this.disableButton = false;
            this.$store.state.crashCourseMaterials.lecture_videoList.push(
              response.result
            );
            this.color = "success";
            this.noticeMessage = response.messages;
            this.snack("top");
          } else {
            this.noticeMessage = response.messages;
            this.snack("top");
            this.lectureDialog = false;
            this.disableButton = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
</script>
<style  scoped>
.progress_parent,
.progress_child {
  height: 20px;
  border-radius: 5px;
}
.progress_parent {
  width: 100%;
  background: #efecec;
}
.progress_child {
  background: #ccb300;
  -webkit-transition: width 0.5s; /* For Safari 3.1 to 6.0 */
  transition: width 0.52s;
}
.textCenter {
  position: fixed;
  left: 48%;
  margin-top: 2px;
}
</style>
